module.exports = __webpack_public_path__ + "static/media/vikings.1e4e8d82.png";